<div class="feedback-page-section">
    <div class="feedback-form-section">
        <div class="feedback-form-logo-section">
            <img src="assets/login.png" class="feedback-form-logo" />
        </div>
        <p class="feedback-form-heading">Send us Feedback</p>
        <div class="feedback-form-input-section">
            <p class="feedback-form-input-label">Query</p>
            <input type="text" class="feedback-form-input" [(ngModel)]="feedback_data.query" />
            <p class="feedback-form-input-error" *ngIf="feedback_data_errors.query">Query is Required.</p>
        </div>
        <div class="feedback-form-input-section">
            <p class="feedback-form-input-label">Description</p>
            <textarea class="feedback-form-input feedback-form-textarea" [(ngModel)]="feedback_data.description"></textarea>
            <p class="feedback-form-input-error" *ngIf="feedback_data_errors.description">Description is Required.</p>
        </div>
        <div class="feedback-form-input-section">
            <p class="feedback-form-input-label">Upload Attachment</p>
            <input type="file" #file_upload style="display: none;" (change)="uploadAttachment($event)" />
                <button class="upload-button" (click)="file_upload.click()">Upload</button>
                <span>{{feedback_data.query_image_name}}</span>
            <p class="feedback-form-input-error" *ngIf="feedback_data_errors.query_image">Attachment is Required.</p>
        </div>
        <div class="feedback-form-input-section">
            <p class="feedback-form-input-label">Criticality</p>
            <mat-select class="feedback-form-input" [(ngModel)]="feedback_data.criticality">
                <mat-option [value]="''">Select Criticality</mat-option>
                <mat-option [value]="'High'">High</mat-option>
                <mat-option [value]="'Medium'">Medium</mat-option>
                <mat-option [value]="'Low'">Low</mat-option>
            </mat-select>
            <p class="feedback-form-input-error" *ngIf="feedback_data_errors.criticality">Criticality is Required.</p>
        </div>
        <div class="feedback-form-button-section">
            <button class="feedback-form-button" *ngIf="!submit_feedback_loader" (click)="submitFeedback()">Submit</button>
            <button class="feedback-form-button" *ngIf="submit_feedback_loader">Submitting ...</button>
        </div>
    </div>
</div>